var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.602 25.2654L24.5007 29.4063H27.834L9.16732 2.73964H5.83398L9.29907 7.68976C8.85091 7.90328 8.41136 8.13714 7.98185 8.39094C5.40187 9.91547 3.27864 12.1037 1.83398 14.7292V17.3959C3.28016 20.0199 5.40383 22.2091 7.98354 23.7329C10.5632 25.2567 13.5045 26.0626 16.5007 26.0626C18.2396 26.0626 19.96 25.7911 21.602 25.2654ZM18.2462 20.4714L11.7036 11.1248C10.9483 12.1283 10.5007 13.3765 10.5007 14.7292C10.5007 18.0429 13.1869 20.7292 16.5007 20.7292C17.1078 20.7292 17.6938 20.6391 18.2462 20.4714ZM31.1673 17.3959C29.8328 19.8172 27.9215 21.8684 25.6072 23.368L21.6807 17.7588C22.2019 16.8696 22.5007 15.8343 22.5007 14.7292C22.5007 11.4155 19.8144 8.72922 16.5007 8.72922C16.1342 8.72922 15.7754 8.76208 15.4271 8.825L13.6625 6.30424C14.5964 6.14371 15.5457 6.06221 16.5007 6.06256C19.4974 6.06147 22.4395 6.8664 25.0194 8.39094C27.5994 9.91547 29.7227 12.1037 31.1673 14.7292V17.3959Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossEye);
export default __webpack_public_path__ + "static/media/crossEye.0c2cfa6a150c92b3767c49e10271cc76.svg";
export { ForwardRef as ReactComponent };